module.exports = __webpack_public_path__ + "static/img/1-2.4e87f9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/1-2.png
// module id = nYQr
// module chunks = 0